import {
  Action,
  getModule,
  Module,
  Mutation,
  VuexModule,
} from "vuex-module-decorators";
import { getUserInfo, getUserPermissions, login, logout } from "@/api/users";
import { getToken, removeToken, setToken } from "@/utils/cookies";
import { resetRouter } from "@/router";
import store from "@/store";
import {CHANGE_COMPANY_OPTIONS} from "@/constant";

export interface IUserState {
  token: string;
  name: string;
  roles: string[];
}

@Module({ dynamic: true, store, name: "user" })
class User extends VuexModule implements IUserState {
  public token = getToken() || "";
  public name = "";
  public avatar =
    "https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif";
  public roles: string[] = [];
  public accountType: string[] = [];
  public routes: any[] = [];

  @Mutation
  private SET_TOKEN(token: string) {
    this.token = token;
  }

  @Mutation
  private SET_NAME(name: string) {
    this.name = name;
  }

  @Mutation
  private SET_ROLES(roles: string[]) {
    this.roles = roles;
  }

  @Mutation
  private SET_ROUTES(routes: any[]) {
    this.routes = routes;
  }

  @Mutation
  private SET_ACCOUNT_TYPE(accountType: string[]) {
    this.accountType = accountType;
  }

  @Action
  public async Login(userInfo: { username: string; password: string }) {
    const username = userInfo.username.trim();
    const password = userInfo.password;
    const token: any = await login({ username, password });
    setToken(token);
    this.SET_TOKEN(token);
  }

  @Action
  public ResetToken() {
    removeToken();
    this.SET_TOKEN("");
    this.SET_ROLES([]);
    this.SET_ACCOUNT_TYPE([]);
  }

  @Action({ rawError: true })
  public async GetUserInfo() {
    if (this.token === "") {
      throw Error("GetUserInfo: token is undefined!");
    }
    const { role, name, accountType, receiptType }: any = await getUserInfo();
    if (role) {
      this.SET_ROLES([role.name]);
    } else {
      this.SET_ROLES(['UNKNOWN']);
    }
    this.SET_NAME(name);
    this.SET_ACCOUNT_TYPE([accountType])
    CHANGE_COMPANY_OPTIONS(receiptType)
  }

  @Action
  public async ChangeRoles(role: string) {
    // Dynamically modify permissions
    const token = role + "-token";
    this.SET_TOKEN(token);
    setToken(token);
    await this.GetUserInfo();
    resetRouter();
    // Generate dynamic accessible routes based on roles
  }

  @Action
  public async Logout() {
    if (this.token && this.token !== "") {
      await logout();
      removeToken();
      resetRouter();
      this.SET_TOKEN("");
    }
  }

  @Action({ rawError: true })
  async GetUserPermissions() {
    const routers: any = await getUserPermissions();
    this.SET_ROUTES(routers);
  }
}

export const UserModule = getModule(User);
